<template>
  <div id="choices">
    <div
      v-if="!showAll"
      class="choices"
      :class="this.$isPC ? '' : 'sp-choices'"
    >
      <router-link
        v-for="(item, index) in items"
        :key="index"
        :for="item.key"
        :to="{
          name: 'Choice',
          params: {
            type: item.key,
          },
        }"
      >
        <label
          v-bind:class="[$route.params.type == item.key ? 'selected' : '']"
        >
          <div style="font-size: 26px;">{{ item.title }}</div>
          <div>から選ぶ</div>
        </label>
      </router-link>
    </div>

    <div class="choice-body">
      <div v-if="showAll" class="choices" style="margin-top: 30px;">
        <label class="selected" style="cursor: default;">
          <h2>
            <div style="font-size: 26px;">目的</div>
            <div>から選ぶ</div>
          </h2>
        </label>
      </div>
      <choice-by-purpose
        v-show="this.$route.params.type == 'purpose' || showAll"
        v-if="this.$isPC"
      />
      <sp-choice-by-purpose
        v-show="this.$route.params.type == 'purpose' || showAll"
        v-else
      />
      <div v-if="showAll" class="choices" style="margin-top: 30px;">
        <label class="selected" style="cursor: default;">
          <h2>
            <div style="font-size: 26px;">業種</div>
            <div>から選ぶ</div>
          </h2>
        </label>
      </div>
      <choice-by-industry
        v-show="this.$route.params.type == 'industry' || showAll"
      />
      <div v-if="showAll" class="choices" style="margin-top: 30px;">
        <label class="selected" style="cursor: default;">
          <h2>
            <div style="font-size: 26px;">機能</div>
            <div>から選ぶ</div>
          </h2>
        </label>
      </div>
      <choice-by-function
        v-show="this.$route.params.type == 'function' || showAll"
      />
    </div>
  </div>
</template>

<script>
import ChoiceByPurpose from '@/components/modules/choice/ChoiceByPurpose'
import SpChoiceByPurpose from '@/components/modules/choice/SpChoiceByPurpose'
import ChoiceByIndustry from '@/components/modules/choice/ChoiceByIndustry'
import ChoiceByFunction from '@/components/modules/choice/ChoiceByFunction'

export default {
  props: ['showAll'],
  components: {
    ChoiceByPurpose,
    SpChoiceByPurpose,
    ChoiceByIndustry,
    ChoiceByFunction,
  },
  title() {
    let pickedName = ''
    switch (this.picked) {
      case 'purpose':
        pickedName = '目的から選ぶ'
        break
      case 'industry':
        pickedName = '業種から選ぶ'
        break
      case 'function':
        pickedName = '機能から選ぶ'
        break
    }

    const moziretu =
      '商品の選び方' +
      ' ' +
      pickedName +
      '｜呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call'
    return moziretu
  },
  meta() {
    let pickedName = ''
    switch (this.picked) {
      case 'purpose':
        pickedName = '目的から選ぶ'
        break
      case 'industry':
        pickedName = '業種から選ぶ'
        break
      case 'function':
        pickedName = '機能から選ぶ'
        break
    }
    const moziretu =
      '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call。「' +
      pickedName +
      '」ページ。飲食店、工場、病院等で活用。フォームお見積りキャンペーンやデモ機の1週間無料レンタルも行なっております、まずはお試しから可能となっております。'
    return moziretu
  },
  data() {
    if (!this.$route.params.type) {
      this.$route.params.type = 'industry'
    }

    return {
      items: [
        { title: '目的', key: 'purpose' },
        { title: '業種', key: 'industry' },
        { title: '機能', key: 'function' },
      ],
      picked: this.showAll ? '' : this.$route.params.type,
    }
  },
}
</script>

<style scoped>
h2 {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  display: unset;
}

#choices {
  width: 100%;
}

.choices {
  display: flex;
  justify-content: space-around;

  width: 50%;
  margin: 0 auto 30px;
}

.sp-choices {
  width: 80%;
}

.choices a {
  text-decoration: none;
}

.choices label {
  font-weight: bold;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  width: 120px;
  height: 120px;

  cursor: pointer;
  text-align: center;

  color: white;
  border-radius: 50%;
  background: rgb(35, 145, 235);
}

.sp-choices label {
  width: 80px;
  height: 80px;
}

.choices label.selected {
  background: rgb(26, 87, 167);
}

.choice-body {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/choice/Choices.vue